import m from "../../geodata/es2015/finlandLow";
window.am4geodata_finlandLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/finlandLow.js
// module id = null
// module chunks = 